
// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import loaderGif from "../src/assets/img/loader.gif";

// const PrivateRoute = ({ children }) => {
//   const [isApiHealthy, setIsApiHealthy] = useState(null);
//   const Token = localStorage.getItem("_ux98c_v1");

//   useEffect(() => {
//     if (!Token) {
//       setIsApiHealthy(false);
//       return;
//     }

//     const checkApiHealth = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_URL}/employee/employee`,
//           {
//             method: "POST",
//             headers: {
//               Authorization: `Bearer ${Token}`,
//             },
//           }
//         );

//         setIsApiHealthy(response.ok);
//       } catch (error) {
//         console.error(error);
//         setIsApiHealthy(false);
//       }
//     };

//     checkApiHealth();
//   }, [Token]);

//   if (isApiHealthy === null) {
//     return (
//       <div className="loading-overlay">
//         <img src={loaderGif} alt="Loading..." />
//       </div>
//     );
//   }

//   if (!Token || !isApiHealthy) {
//     return <Navigate to="/" />;
//   }

//   return children;
// };

// export default PrivateRoute;
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const Token = localStorage.getItem("_ux98c_v1");

  if (!Token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;